<template>
    <v-app-bar
      id="app-bar"
      absolute
      app
      color="transparent"
      flat
      height="75"
    >
      <v-btn
        class="mr-3"
        elevation="1"
        fab
        small
        @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
      >
        <v-icon v-if="value">
          mdi-view-quilt
        </v-icon>

        <v-icon v-else>
          mdi-dots-vertical
        </v-icon>
      </v-btn>

      <v-toolbar-title
        class="hidden-sm-and-down font-weight-light"
        v-text="$route.name"
      />

      <v-spacer />

      <div class="mx-3" />

      <!--<v-menu
        v-model="menu"
        bottom
        left
        offset-y
        origin="top right"
        transition="scale-transition"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            class="ml-2"
            min-width="0"
            text
            v-bind="attrs"
            v-on="on"
          >
            <v-badge
              color="red"
              overlap
              bordered
            >
              <template v-slot:badge>
                <span>{{ item_length }}</span>
              </template>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-card class="ma-0">
          <v-card-title style="font-size: 100%" class="indigo mb-0">
            <v-icon color="white">
              mdi-bell
            </v-icon>
            <div v-if="item_length > 0" class="ml-9 white--text">
              Notificaciones
            </div>
            <div v-else class="ml-9 white--text">
              Sin Notificaciones
            </div>
          </v-card-title>
          <v-list>
            <v-divider />
            <template v-if="showLess">
              <v-list-item-group :v-model="notifications" color="primary">
                <v-list-item
                  v-for="(item, i) in notifications.slice(0, maxNotifications)"
                  :key="i"
                  @click="removeNotification(item)"
                >
                  <template v-if="i < maxNotifications">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon" />
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.message" />
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </template>
            <template v-else>
              <v-list-item-group :v-model="notifications" color="primary">
                <v-list-item v-for="(item, i) in notifications" :key="i" @click="removeNotification(item)">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.message"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </template>
            <v-divider />
            <template v-if="item_length > maxNotifications">
              <v-btn block text small color="indigo" @click="showLess = !showLess">
                <div v-if="showLess">
                  Ver más
                </div>
                <div v-else>
                  Ver menos
                </div>
              </v-btn>
            </template>
          </v-list>
        </v-card>
      </v-menu>-->

      <v-menu
        bottom
        left
        min-width="200"
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            class="ml-2"
            min-width="0"
            text
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list
          :tile="false"
          flat
          nav
        >
          <template v-for="(p, i) in profile">
            <v-divider v-if="p.divider" :key="`divider-${i}`" class="mb-2 mt-2" />
            <v-row v-if="p.showDarkmode" :key="`showDarkmode-${i}`" align="center" no-gutters class="my-2 mx-6">
              <v-col cols="auto">
                Dark Mode
              </v-col>
              <v-col cols="auto">
                <v-switch v-model="$vuetify.theme.dark" class="ma-0 pa-0" color="secondary" hide-details @change="guardarModo" />
              </v-col>
            </v-row>
            <app-bar-item v-else-if="!p.divider" :key="`item-${i}`" :to="p.route">
              <v-list-item-title v-text="p.title" />
            </app-bar-item>
          </template>
        </v-list>
      </v-menu>
    </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      notifications: [],
      maxNotifications: 5,
      showLess: true,
      menu: false,
      profile: [
        { showDarkmode: true },
        { divider: true },
        { title: 'Cambiar contraseña', route: '/ver/cambiarContrasena' },
        { title: 'Cerrar sesión', route: '/auth/logout' },
      ],
    }),
    computed: {
      ...mapState(['drawer', 'darkMode']),
      item_length: function () {
        return this.notifications.length
      },
    },
    mounted () {
      this.getNotifications()
      this.$vuetify.theme.dark = (this.darkMode === 'true' || this.darkMode === true)
    },
    created () {
    },
    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
        setDarkMode: 'Set_darkMode',
      }),
      guardarModo () {
        this.$store.dispatch('axiosMod/changeDarkMode', { valorActual: this.$vuetify.theme.dark })
        this.setDarkMode(this.$vuetify.theme.dark)
      },
      getNotifications: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/alerta_local' }).then(response => { this.notifications = response })
      },
      removeNotification (item) {
        this.menu = false
        this.$delete(this.notifications, this.notifications.indexOf(item))
        this.$router.push({ name: item.route })
      },
    },
  }
</script>
